import { useEffect } from 'react';
import { useCompanySettings } from './useCompanySettings';

export function useFavicon() {
  const companySettings = useCompanySettings();

  useEffect(() => {
    const faviconUrl = companySettings.favicon || '/favicon.ico';
    const appleUrl = companySettings.favicon || '/logo192.png';

    const upsertLink = (rel, href) => {
      let link = document.querySelector(`link[rel='${rel}']`);
      if (!link) {
        link = document.createElement('link');
        link.rel = rel;
        document.head.appendChild(link);
      }
      link.href = href;
    };

    upsertLink('icon', faviconUrl);
    upsertLink('shortcut icon', faviconUrl);
    upsertLink('apple-touch-icon', appleUrl);
  }, [companySettings.favicon]);
}
